export const useGAnalytics = () => {
  const trackEvent = (eventName: string, params: any = null) => {
    try {
      const isBrowser = typeof window !== "undefined" && typeof navigator !== "undefined";
      const userDevice = isBrowser
        ? {
            userAgent: navigator.userAgent,
            platform: navigator.platform,
            language: navigator.language,
          }
        : {};

      const eventParams = {
        ...userDevice,
        ...params,
      };

      if (isBrowser) {
        useGtag().gtag("event", eventName, eventParams);
      }
    } catch (error) {
      console.error(error);
    }
  };
  return {
    trackEvent,
  };
};
